<script setup lang="ts">
import dayjs from 'dayjs';
import { isActiveorPreActive } from 'ui/components/renters/statusFunctions';
import type { RentersPolicyStatusType } from 'ui/components/renters/enums';

const props = defineProps<{
  startDate: string;
  status: RentersPolicyStatusType;
  endDate?: string;
  autoRenew?: boolean;
  neverHadCoverage?: boolean;
}>();

const endBeforeStart = computed(
  () => !!props.endDate && dayjs(props.endDate).isBefore(dayjs(props.startDate), 'day'),
);

const showNoCoverage = computed(() => !!props.neverHadCoverage || endBeforeStart.value);
</script>

<template>
  <div v-if="showNoCoverage" class="flex gap-1">
    <div>No coverage</div>
  </div>
  <div v-else class="flex gap-1">
    <div>{{ dayjs(startDate).format('MM/DD/YYYY') }}</div>
    <div>-</div>
    <div>
      <template v-if="isActiveorPreActive(status) && autoRenew">Autorenew</template>
      <template v-else>{{ endDate ? dayjs(endDate).format('MM/DD/YYYY') : '' }}</template>
    </div>
  </div>
</template>
